import { createStateContext, createReducerContext } from "react-use";
import { merge } from "lodash";

const [useSharedState, SharedStateProvider] = createStateContext({});

const reducer = (state, action) => {
  switch (action.type) {
    case "MERGE":
      return merge({ ...state }, action.payload);
    default:
      throw new Error();
  }
};

const [useSharedBookReducer, SharedBookReducerProvider] = createReducerContext(
  reducer,
  {}
);

export {
  useSharedState,
  SharedStateProvider,
  useSharedBookReducer,
  SharedBookReducerProvider,
};
